import React from 'react'
import { Alert, Snackbar } from '@common/components'
import { useAppDispatch, useAppSelector } from '@common/hooks'
import { setToasts } from './toast.slice'

const Toast = () => {
  const { toasts } = useAppSelector((state) => state.toast)
  const dispatch = useAppDispatch()
  const handleChange = setToasts((elems) => dispatch(setToasts(elems)))
  const [open, setOpen] = React.useState(false)
  const [messageInfo, setMessageInfo] = React.useState(undefined)

  React.useEffect(() => {
    if (toasts.length && !messageInfo) {
      setMessageInfo({ ...toasts[0] })
      dispatch(setToasts(toasts.slice(1)))
      setOpen(true)
    } else if (toasts.length && messageInfo && open) {
      setOpen(false)
    }
  }, [toasts, messageInfo, open])

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpen(false)
  }

  const handleExited = () => {
    setMessageInfo(undefined)
  }

  return (
    <Snackbar
      key={messageInfo ? messageInfo.key : undefined}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      TransitionProps={{ onExited: handleExited }}
    >
      <Alert
        variant='filled'
        onClose={handleClose}
        severity={messageInfo ? messageInfo.severity : 'info'}
      >
        {messageInfo ? messageInfo.message : undefined}
      </Alert>
    </Snackbar>
  )
}

Toast.defaultProps = {
  variant: 'filled',
}

export default Toast
